<template>
  <cf-expandable-section class="cf-list-item-border-bottom cf-padding-bottom-16">
    <template #title>
      <h3 class="cf-title cf-title--3">
        {{ faqCategory.name }}
      </h3>
    </template>

    <template #content>
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <category-question
          v-for="(faqCategoryItem, index) in faqCategory.items"
          :key="index"
          :faq-category-item="faqCategoryItem"
        />
      </div>
    </template>
  </cf-expandable-section>
</template>


<script>
  import CfExpandableSection from '@/view/components/shared/cf-expandable-section/index.vue';

  import CategoryQuestion from '../category-question/index.vue';


  export default {
    name: 'FaqCategory',

    components: {
      CategoryQuestion,
      CfExpandableSection
    },

    props: {
      faqCategory: {
        type: Object,
        required: true
      }
    }
  };
</script>
